import React from 'react';
import Historia from '../components/Historia';
import Footer from '../components/Footer';
import Cart from '../components/Cart';

const HistoriaPage = () => {
  return (
    <>
      <Historia />
      <Cart />
      <Footer />
    </>
  );
};

export default HistoriaPage;
